<!--
 * @Description: 异动反馈情况
 * @Author: cxh
 * @Date: 2023-05-16 17:14:17
 * @LastEditTime: 2023-05-19 10:18:52
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <cos-table :columns="columns" v-model:search="searchFrom" @fetch="fetch" tableId="fbuFollowChangeFeedback">
        <template #search>
          <a-form :model="searchFrom">
            <dc-form-item label="主客户代码">
              <a-input v-model:value="searchFrom.customerNumber" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="子客户代码">
              <a-input v-model:value="searchFrom.arkCode" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="客户名称">
              <a-input v-model:value="searchFrom.customerName" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="createTime" label="异动触发时间">
              <cos-range-picker
                v-model:startTime="searchFrom.startAlarmDate"
                v-model:endTime="searchFrom.endAlarmDate"
              />
            </dc-form-item>
            <dc-form-item name="seller" label="客户负责人">
              <user-select v-model:value="searchFrom.seller" />
            </dc-form-item>
            <dc-form-item label="异动类型">
              <a-select v-model:value="searchFrom.alarmType" placeholder="请选择" allowClear :options="alarmTypeEnum" />
            </dc-form-item>
            <dc-form-item label="异动级别">
              <a-select
                v-model:value="searchFrom.alarmLevelList"
                placeholder="请选择"
                mode="multiple"
                allowClear
                :options="alarmLevelEnum"
              />
            </dc-form-item>
            <dc-form-item label="反馈情况">
              <a-select
                v-model:value="searchFrom.processStatusList"
                placeholder="请选择"
                allowClear
                mode="multiple"
                :options="alarmProcessStatusEnum"
              />
            </dc-form-item>
          </a-form>
        </template>
        <template #button>
          <ExportButton
            appId="cos_fbu"
            taskType="213"
            :search="searchFrom"
            v-permission="'fbu_followChangeFeedback_export_btn'"
            >导出</ExportButton
          >
        </template>
        <template #bodyCell="{ column, text }">
          <template v-if="column.dataIndex === 'process'">
            <EditorTableText :value="text" />
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import { ref, onMounted, computed } from 'vue'
import { FollowAlarmParams } from '@/typings/api/analysis'
import { followAlarmGet } from '@/api/gucangSales/analysis'
import { listByParamCodes } from '@/api/common'
import EditorTableText from '@/components/Editor/src/tableText.vue'
import { alarmTypeEnum, alarmLevelEnum, alarmCustomerLevelEnum, alarmProcessStatusEnum } from '@/views/gucangSales/commonEnum/dataConfig'
export default { name: 'fbu_followChangeFeedback' }
</script>
<script setup lang="ts">
const searchFrom = ref<FollowAlarmParams>({})
const paramCodeData = ref<any>({
  fbu_change_description: [] // 异动说明
})
const columns = computed(() => [
  {
    title: '主客户代码',
    dataIndex: 'customerNumber',
    fixed: 'left',
    width: 150
  },
  {
    title: '客户名称',
    dataIndex: 'customerName'
  },
  {
    title: '子客户代码',
    dataIndex: 'arkCode'
  },
  {
    title: '客户负责人',
    dataIndex: 'sellerName'
  },
  {
    title: '异动触发时间',
    dataIndex: 'alarmDate'
  },
  {
    title: '异动级别',
    dataIndex: 'alarmLevel',
    dicData: alarmLevelEnum
  },
  {
    title: '客户量级',
    dataIndex: 'customerLevel',
    dicData: alarmCustomerLevelEnum
  },
  {
    title: '异动类型',
    dataIndex: 'alarmType',
    dicData: alarmTypeEnum
  },
  {
    title: '异动原因',
    dataIndex: 'alarmInfo'
  },
  {
    title: '异动说明',
    dataIndex: 'alarmDesc',
    dicData: paramCodeData.value.fbu_change_description
  },
  {
    title: '具体详情',
    dataIndex: 'process'
  },
  {
    title: '反馈时间',
    dataIndex: 'processTime'
  },
  {
    title: '反馈情况',
    dataIndex: 'processStatus',
    dicData: alarmProcessStatusEnum
  }
])
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: ['fbu_change_description']
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.value = res.data
    }
  })
}
const fetch = (params: FollowAlarmParams, callBack: (res: any) => void) => {
  followAlarmGet({
    ...params
  }).then((res) => {
    callBack(res)
  })
}
</script>
